import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class NewCustomerCountByRecipientService {

  constructor(
    private http: HttpService,
  ) { }

  filter(data?: any) {
    return this.http.post(Path.NEW_CUSTOMER_COUNT_REPORT.FILTER, data);
  }

  generate(data?: any) {
    return this.http.post(Path.NEW_CUSTOMER_COUNT_REPORT.GENERATE, data);
  }

  getList(data?: any) {
    return this.http.post(Path.NEW_CUSTOMER_COUNT_REPORT.GET_LIST, data)
  }

}
